import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForConfluenceBuyReverseTrialExperiment(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		invoiceableStatus,
		isInReverseTrial,
		isInTrial,
		isInPredunning,
		isInCollection,
	} = context;

	return Boolean(
		!isInCollection &&
			product === 'confluence' &&
			edition === 'premium' &&
			(isInTrial || isInPredunning) &&
			isInReverseTrial &&
			invoiceableStatus === 'NOT_INVOICEABLE',
	);
}
